import { useLocation } from "react-router";

const Footer = () => {
  const { pathname } = useLocation();

  if (pathname === "/intro") {
    return <></>;
  } else {
    return (
      <div className="border-t-[1px] pt-3 pb-2">
        <p className="text-center text-xs font-rokh">
          تمامی حقوق برای <strong>بــادی‌بان</strong> محفوظ است
        </p>
      </div>
    );
  }
};

export default Footer;
